import React from 'react';
import PropTypes from 'prop-types';
import {stripHtml} from '../../../../utils/text';

const ChoiceOption = ({id, value}) => (
    <option value={id}>{id}: {stripHtml(value)}</option>
);

ChoiceOption.propTypes = {
    id: PropTypes.string.isRequired,
    value: PropTypes.string,
};

export default ChoiceOption;
